<template>
    <div id="schoolSignupNoticeList">
        <div>
            <div class="second-header-wrap">
                <school-year-selector @change="getVoteTwoRecruitNoticeListFunc"></school-year-selector>
                <el-button type="primary" @click="jumpToPage('noticeAdd')" size="medium" v-if="isSelectedYearCurrent">新建</el-button>
            </div>
        </div>
        <div class="table-container">
            <el-table
                ref="messageTable"
                :data="dataList"
                class="messageTable custom—scrollbar"
                fit
                style="width: 100%"
                border
            >
                <el-table-column
                    label="主题" align="center" show-overflow-tooltip width="300">
                    <template slot-scope="scope">
                        <router-link :to="{path: 'noticeDetail', query: {id: scope.row.id}}">{{scope.row.title}}
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column
                    label="报名开始时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.startDate | secondTimeFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="报名截止时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.endDate | secondTimeFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="出生日期限制" align="center">
                    <template slot-scope="scope">
                        {{scope.row.minBirthday}}至{{scope.row.maxBirthday}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="招生人数" align="center">
                    <template slot-scope="scope">
                        {{scope.row.maxRecruitCount}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        {{ scope.row.status === 1 ? '草稿' : '已发布' }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="发布人" align="center" prop="createUserName">
                </el-table-column>
                <el-table-column
                    label="发布时间" align="center" prop="">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sendTime">{{scope.row.sendTime | timeSuffixFilter}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" v-if="isSelectedYearCurrent">
                    <template slot-scope="scope">
                        <el-button size="small" type="text"
                                   @click.native="jumpToPage('noticeEdit', {id: scope.row.id})">
                            编辑
                        </el-button>
                        <el-button size="small" type="text" @click="deleteHandler(scope.row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import SchoolYearSelector from '@/components/SchoolYearSelector';
    import {
        getVoteTwoRecruitNoticeList,
        delVoteTwoRecruitNotice
    } from '@/api/notice';
    import baseMixin from '@/mixins/baseMixin';
    import {mapGetters} from 'vuex';

    export default {
        name: "NoticeList",
        data() {
            return {
                dataList: [],
                selection: []
            }
        },
        mixins: [baseMixin],
        computed: {
            ...mapGetters(['isSelectedYearCurrent'])
        },
        components: {SchoolYearSelector},
        filters: {
            secondTimeFilter(value) {
                return value.substring(0, 16);
            }
        },
        created() {
            this.getVoteTwoRecruitNoticeListFunc();
        },
        methods: {
            getVoteTwoRecruitNoticeListFunc() {
                getVoteTwoRecruitNoticeList()
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data;
                    });
            },
            deleteHandler(id) {
                this.$confirm('是否确认删除?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delVoteTwoRecruitNotice({
                        noticeId: id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getVoteTwoRecruitNoticeListFunc();
                            }
                        })
                }).catch(() => {
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }

    .main-wrap {
        width: 100%;
        margin-top: 229px;
    }

    .main-container {
        width: 1320px;
        padding: 30px 10px;
        margin: 0 auto;
        min-height: 560px;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
</style>
<style>
    #schoolSignupNoticeList a {
        color: #409EFF;
        text-decoration: none;
    }
</style>




// WEBPACK FOOTER //
// src/views/kindergarten/notice/NoticeList.vue